<template>
  <a-layout-content>
    <a-form layout="inline">
      <a-form-item label="状态">
        <a-select v-model="input.State" style="width: 120px" @change="query">
          <a-select-option value="0"> 关闭</a-select-option>
          <a-select-option value="1"> 启用</a-select-option>
          <a-select-option value="2"> 全部</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <div class="body-nest">
      <a-table
        bordered
        row-key="ID"
        size="middle"
        :columns="columns"
        :data-source="datarow"
        :pagination="pagination"
        @change="changepage"
      >
        <template slot="title">
          <a-row>
            <a-col style="float: left">
              <a href="javascript:;" @click="CreateActivie()">
                <a-button type="primary"
                  ><a-icon type="plus"></a-icon>创建优惠活动</a-button
                >
              </a>
            </a-col>
          </a-row>
        </template>
        <template slot="State" slot-scope="text, record">
          <a-tag v-if="record.State == '0'" color="red">否</a-tag>
          <a-tag v-else-if="record.State == '1'" color="cyan">是</a-tag>
        </template>
        <template slot="Show" slot-scope="text, record">
          <a-tag v-if="record.Show == '0'" color="red">否</a-tag>
          <a-tag v-else-if="record.Show == '1'" color="cyan">是</a-tag>
        </template>
        <template slot="PhoneShow" slot-scope="text, record">
          <a-tag v-if="record.PhoneShow == '0'" color="red">否</a-tag>
          <a-tag v-else-if="record.PhoneShow == '1'" color="cyan">是</a-tag>
        </template>
        <template slot="Operation" slot-scope="text, record">
          <a-tooltip title="编辑">
            <a @click="editactive(record)">
              <a-icon type="edit" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
          &nbsp;&nbsp;
          <a-tooltip title="删除">
            <a @click="deleteactive(record)">
              <a-icon type="delete" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
          &nbsp;&nbsp;
          <a-tooltip title="封面上传">
            <a href="javascript:;" @click="onUpdateImage(record)">
              <a-icon type="upload" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
          &nbsp;&nbsp;
          <a-tooltip title="表单配置">
            <a @click="editform(record)">
              <a-icon type="snippets" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
        </template>
      </a-table>
    </div>

    <!-- 对话框 ------------------------------------->
    <a-modal v-model="visible" title="上传封面" @ok="UploadOK">
      <a-form-model
        :model="formModel"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="PC版封面">
          <img
            style="width: 100px; heigth: 100px"
            v-if="pcimageUrl"
            :src="pcimageUrl"
            alt="avatar"
          />
          <a-upload
            :before-upload="pcUpload"
            list-type="picture"
            :file-list="pcfile"
            :remove="pcRemove"
          >
            <a-button> <a-icon type="upload" /> 选取图片 </a-button>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="手机版封面">
          <img
            style="width: 100px; heigth: 100px"
            v-if="h5imageUrl"
            :src="h5imageUrl"
            alt="avatar"
          />
          <a-upload
            list-type="picture"
            :file-list="appfile"
            :before-upload="appUpload"
            :remove="appRemove"
          >
            <a-button> <a-icon type="upload" /> 选取图片 </a-button>
          </a-upload>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout-content>
</template>
<script>
let datarow = [];
import moment from "moment";

export default {
  data() {
    return {
      //------table --------
      columns: IninTable(),
      datarow,
      pagination: {
        total: 0,
        pageindex: 1,
        pagesize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true, // 可以改变每页个数
        pageSizeOptions: ["10", "20", "30", "50","100","500","1000"],
        onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize),
      },
      //--------------------
      input: {
        State: "2",
      },
      visible: false, //弹框状态
      formModel: {}, // 弹框字段
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      pcfile: [],
      appfile: [],
      pcimageUrl: false,
      h5imageUrl: false,
    };
  },
  methods: {
    moment,
    query() {
      let params = {
        State: parseInt(this.input.State),
        pageindex: this.pagination.pageindex,
        pagesize: this.pagination.pagesize,
      };

      this.axios.post("/promotions/getpromotionlist", params).then((res) => {
        this.datarow = res.data;
        this.pagination.total = res.total;
      });
    },
    //翻页
    changepage(e) {
      this.pagination.pageindex = e.current;
      this.pagination.pagesize = e.pageSize;
      this.query();
    },
    // 创建活动
    CreateActivie() {
      this.$router.push({
        name: "createactivie",
        params: { action: "add", id: 0 },
      });
    },
    //编辑活动
    editactive(record) {
      this.$router.push({
        name: "createactivie",
        params: { action: "edit", id: record.ID },
      });
    },
    //上传封面
    onUpdateImage(record) {
      this.formModel = { ...record };
      this.appfile = [];
      this.pcfile = [];
      //图片显示
      if (this.formModel.Image !== "") {
        this.pcimageUrl = this.formModel.Image;
      }
      if (this.formModel.PhoneImage !== "") {
        this.h5imageUrl = this.formModel.PhoneImage;
      }
      this.visible = true;
    },
    //删除活动
    deleteactive(record) {
      let _this = this;

      let params = {
        ID: record.ID,
        Name: "",
        Url: "",
        Sort: "0",
        State: 0,
        ShowPC: 0,
        ShowPhone: 0,
        Limitcount: "0",
        Limittip: "",
        PCConent: "",
        PhoneConent: "",
        Image: "",
        PhoneImage: "",
        Type: 3,
      };
      this.$confirm({
        title: "删除活动",
        content: "您要确定要删除活动吗?",
        onOk() {
          _this.axios.post("/promotions/deleteprommotion", params).then((res) => {
            if (res.data) {
              _this.$message.success("删除成功");
              _this.query();
            }
          });
        },
      });
    },
    //表单配置
    editform(record) {
      this.$router.push({
        name: "formconfiguration",
        params: { activiesName: record.ActiviesName, id: record.ID },
      });
    },
    isExcel(file) {
      return /\.(jpg|png)$/.test(file.name);
    },
    //pc上传
    pcUpload(file) {
      if (!this.isExcel(file)) {
        this.$message.error("仅支持上传.jpg、.png、后缀文件");
        return false;
      }
      this.pcfile = [file];
      return false;
    },
    pcRemove(file) {
      const index = this.pcfile.indexOf(file);
      const newFileList = this.pcfile.slice();
      newFileList.splice(index, 1);
      this.pcfile = newFileList;
    },
    appRemove(file) {
      const index = this.appfile.indexOf(file);
      const newFileList = this.appfile.slice();
      newFileList.splice(index, 1);
      this.appfile = newFileList;
    },
    //app上传
    appUpload(file) {
      if (!this.isExcel(file)) {
        this.$message.error("仅支持上传.jpg、.png、后缀文件");
        return false;
      }
      this.appfile = [file];
      return false;
    },
    UploadOK() {
      let param = new FormData();
      if (this.pcfile.length > 0) {
        param.append(
          "files",
          this.pcfile[0],
          "PC." + this.pcfile[0].name.split(".")[1]
        );
      }
      if (this.appfile.length > 0) {
        param.append(
          "files",
          this.appfile[0],
          "H5." + this.appfile[0].name.split(".")[1]
        );
      }
      param.append("id", this.formModel.ID); // 添加form表单中其他数据
      //console.log(param.get('files')) // FormData私有类对象，访问不到，可以通过get判断值是否传进去
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      // 添加请求头
      let _this = this;
      this.axios.post("/promotions/uploadimage", param, config).then((res) => {
        if (res.data) {
          _this.$message.success("上传成功");
          _this.visible = false;
          _this.query();
        }
      });
    },
  },
  created() {
    this.query();
  },
  watch: {
    $route(to, from) {
      if (to.name === "activielist") {
        this.query();
      }
    },
  },
};

const IninTable = function IninTable() {
  var header = [];
  header.push({ title: "编号", align: "center", width: 80, dataIndex: "ID" });
  header.push({
    title: "活动名称",
    align: "center",
    dataIndex: "ActiviesName",
  });
  header.push({
    title: "排序",
    align: "center",
    width: 80,
    sorter: (a, b) => a.Sort - b.Sort,
    dataIndex: "Sort",
  });
  header.push({
    title: "创建时间",
    align: "center",
    width: 400,
    sorter: (a, b) =>
      new Date(a.Fdt.replace(/[\u4e00-\u9fa5]/g, "")).getTime() -
      new Date(b.Fdt.replace(/[\u4e00-\u9fa5]/g, "")).getTime(),
    dataIndex: "Fdt",
  });
  header.push({
    title: "是否开启",
    align: "center",
    dataIndex: "State",
    width: 100,
    scopedSlots: { customRender: "State" },
  });
  header.push({
    title: "是否显示",
    align: "center",
    dataIndex: "Show",
    width: 100,
    scopedSlots: { customRender: "Show" },
  });
  header.push({
    title: "手机端显示",
    align: "center",
    dataIndex: "PhoneShow",
    width: 100,
    scopedSlots: { customRender: "PhoneShow" },
  });
  header.push({
    title: "操作",
    align: "center",
    width: 300,
    scopedSlots: { customRender: "Operation" },
  });
  return header;
};
</script>

<style>
.clearline {
  border-top: solid #acc0d8 1px;
  margin: 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/promotions/activielist.vue